import { fetchJson } from '@atlassian/jira-fetch';
import type { Sprint } from '../types';

export const getSprint = async (sprintId: string): Promise<Sprint> =>
	fetchJson(`/rest/agile/1.0/sprint/${sprintId}`);
